module.exports = __webpack_public_path__ + "static/clothing-running-shoe-2807f196fa73df8ef9221f9c5a935979.jpg";